import React, { useEffect, useState } from "react";

import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { FilterModel } from "../../../../../../domain/models/enum";

import DocumentsListPage from "../../../../../../presentation/pages/developer/recurrency/list";

import { settings } from "../../../../../configs/settings";


import { generateFilter } from "./utils";
import { makeRemoteFiscalNoteNote } from "../../../../usecases/fiscal-note/remote-fiscal-note-factory";
import { FiscalNoteResponseModel } from "../../../../../../domain/models/fiscal-note";

function MakeDocumentsList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<FiscalNoteResponseModel>();
  const [params, setParams] = useState<FilterModel>({ hasRecurrence: true });
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);

      const data = await makeRemoteFiscalNoteNote().load({
        size: settings.perPage,
        sort: "issuedOn,desc",
        page: params?.page,
        query: params?.query,
        typeNoteFiscalEnum: "RECORRENCE",
        hasRecurrence: params?.hasRecurrence,
        filters: generateFilter({
          ...params?.filters,
        }),
      });
      setList(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleReload();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <DocumentsListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
      isSuperAdmin={!!user?.roles?.find((r: any) => r.authority === "SUPERADMIN")}
    />
  );
}

export default MakeDocumentsList;
